import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['password', 'confirmPassword'];

  check(e) {
    if (this.passwordTarget.value !== this.confirmPasswordTarget.value) {
      window.$sendAlert('비밀번호와 비밀번호 확인이 다릅니다');
      e.preventDefault();
    }
  }
}
